import React, { useEffect, useState } from "react";
import "../../assets/styles/Profile.css";
import { motion } from "framer-motion";
import Header from "../../components/Header.js";
import InfoUser from "../../components/Profile/InfoUser.js";
import imgBtnUser from "../../imgs/fullname.webp";
import imgBtnPhone from "../../imgs/phone_number.webp";
import imgBtnMail from "../../imgs/email.webp";
import imgBtnBank from "../../imgs/bank.webp";
import imgBtnBirthday from "../../imgs/birthday.webp";
import imgBtnUsdt from "../../imgs/usdt.webp";
import imgPassword from "../../imgs/password.webp";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Card from "../../components/Card/Card.js";
import * as yup from "yup";
import Popup from "reactjs-popup";
import HtmlNote from "../../components/Profile/HtmlNote.js";
import { apiGetRequestHistory } from "../../services/api.service.js";
import iconClose from "../../icons/icon-close.png";

const REQUEST_STATUS = { no_process: "Chờ xử lý", approved: "Thành công", removed: "Từ chối" };
const REQUEST_TYPES = { full_name: "Thay đổi họ và tên", phone_number: "Thay đổi số điện thoại", email: "Thay đổi email", bank: "Thay đổi tài khoản ngân hàng", birthday: "Thay đổi ngày sinh", usdt: "Liên kết ví USDT", forget_password: "Cấp lại mật khẩu đăng nhập", forget_password_withdraw: "Cấp lại mật khẩu rút tiền" };

function Profile() {
  const iconCard = [
    {
      icon: imgBtnUser,
      title: "thay đổi họ và tên",
      id: "full_name",
    },
    {
      icon: imgBtnPhone,
      title: "thay đổi sđt",
      id: "phone_number",
    },
    {
      icon: imgBtnMail,
      title: "thay đổi gmail",
      id: "email",
    },
    {
      icon: imgBtnBank,
      title: "đổi stk ngân hàng",
      id: "bank",
    },
    {
      icon: imgBtnUsdt,
      title: "liên kết ví usdt",
      id: "usdt",
    },
    {
      icon: imgBtnBirthday,
      title: "thay đổi ngày tháng năm sinh",
      id: "birthday",
    },
    {
      icon: imgPassword,
      title: "quên mật khẩu",
      id: "forget_password",
    },
  ];

  const location = useLocation();
  const { userName, data, webSetting } = location.state || {};
  const navigate = useNavigate();
  const [requestCode, setRequestCode] = useState("");
  const [requestHistory, setRequestHistory] = useState(null);
  const [requestHistoryError, setRequestHistoryError] = useState("");
  const [openRequestHistoryResult, setOpenRequestHistoryResult] = useState(false);
  const historyCollapsed = false;
  const [showRequestHistoryHelp, setShowRequestHistoryHelp] = useState(false);
  const recentRequests = (data?.recent_requests || []).slice(0, 2);
  // danh sách mục thông tin tài khoản không được phép thay đổi (BE trả về khi check tài khoản)
  const disabledUpdateTypes = data?.disabled_update_types || [];

  const verificationText = (status, sendType) => {
    if (status === "success") return "Đã nhận xác thực hợp lệ";
    if (status === "invalid") return sendType === "email" ? "Xác thực sai địa chỉ email" : "Xác thực sai số điện thoại";
    return sendType === "email" ? "Chưa nhận email xác thực" : "Chưa nhận SMS xác thực";
  };
  const maskCode = (code = "") => String(code).startsWith("xxxxxx") ? String(code) : `xxxxxx${String(code).slice(-2)}`;
  const checkRequestHistory = async () => {
    if (!/^\d{8}$/.test(requestCode)) {
      setRequestHistoryError("Vui lòng nhập đúng mã yêu cầu gồm 8 số.");
      return;
    }
    setRequestHistoryError("");
    const result = await apiGetRequestHistory(userName, requestCode);
    if (result?.code === 200 && result?.data?.request) {
      setRequestHistory(result.data.request);
      setOpenRequestHistoryResult(true);
    } else setRequestHistoryError(result?.message || "Không tìm thấy yêu cầu.");
  };

  const schema = yup.object().shape({
    name: yup.string().required("Name is required"),
    email: yup.string().email("Email is invalid").required("Email is required"),
    phoneNumber: yup
      .string()
      .matches(/^[0-9]+$/, "Phone number must be digits")
      .required("Phone number is required"),
  });

  const shouldNavigate = !userName || userName === "undefined";
  useEffect(() => {
    if (shouldNavigate) {
      navigate("/");
    }
  }, [navigate, shouldNavigate]);

  if (!shouldNavigate) {
    const changeInfo = async (typeModal) => {
      if (!userName) {
        return Swal.fire({
          icon: "error",
          text: "Vui lòng nhập tên tài khoản.",
        });
      } else {
        navigate("/change-info", {
          state: { userName, data, webSetting, typeModal },
        });
      }
    };

    return (
      <div className="container">
        <motion.div
          // className="app"
          // initial={{ opacity: 0 }}
          // animate={{ opacity: 1 }}
          // transition={{ duration: 5 }}
          // className="app"
          // initial={{ x: "-100vw", opacity: 0 }}
          // animate={{ x: 0, opacity: 1 }}
          // exit={{ x: "100vw", opacity: 0 }}
          // transition={{ type: "spring", stiffness: 100, damping: 20 }}
          className="app"
          initial={{ x: "100vw", opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: "-100vw", opacity: 0 }}
          transition={{
            type: "spring",
            stiffness: 1000,
            damping: 200,
            duration: 10,
          }}
        >
          <Header isPageSearch={false} />

          <div className="content">
            <div className="profile">
              <section className="request-history">
                <div className="request-history-heading">
                  <span className="profile-titlte">LỊCH SỬ YÊU CẦU &nbsp;
                    <span className="request-history-help" onMouseEnter={() => setShowRequestHistoryHelp(true)} onMouseLeave={() => setShowRequestHistoryHelp(false)}>
                      <button type="button" className="request-history-help-icon" aria-label="Thông tin lịch sử yêu cầu" onClick={() => setShowRequestHistoryHelp((value) => !value)}>!</button>
                      {showRequestHistoryHelp && <span className="request-history-help-content">Danh sách chỉ hiển thị tối đa 2 yêu cầu gần nhất trong 48 giờ. Nhập mã yêu cầu 8 số để xem chi tiết kết quả xử lý.</span>}
                    </span>
                  </span>
                  <span className="request-history-account">
                    <strong>{userName}</strong>
                  </span>
                </div>
                {!historyCollapsed && <>
                  <div className="recent-requests">
                    {recentRequests.map((request, index) => <div className={`recent-request-item status-${request.status}`} key={`${request.request_code}-${index}`}>
                      <div className="recent-request-main"><strong>{REQUEST_TYPES[request.update_type] || request.update_type}</strong><span className="recent-request-code">Mã yêu cầu: {maskCode(request.request_code)}</span></div>
                      <div className="recent-request-meta"><span className={`recent-request-status status-${request.status}`}>{REQUEST_STATUS[request.status] || request.status}</span>{request.status === "no_process" && ["email", "phone_number"].includes(request.send_type) && <span className={`verification-status verification-${request.verification_status || "not_received"}`}>{verificationText(request.verification_status || "not_received", request.send_type)}</span>}</div>
                    </div>)}
                  </div>
                  <div className="request-history-form">
                    <input inputMode="numeric" maxLength={8} value={requestCode} onChange={(event) => setRequestCode(event.target.value.replace(/\D/g, "").slice(0, 8))} onKeyDown={(event) => event.key === "Enter" && checkRequestHistory()} placeholder="Nhập mã yêu cầu (8 số)" />
                    <button type="button" onClick={checkRequestHistory}>Kiểm tra</button>
                  </div>
                  {requestHistoryError && <p className="request-history-error">{requestHistoryError}</p>}
                </>}
              </section>
              <span className="profile-titlte">THAY ĐỔI MỤC THÔNG TIN MỚI</span>
              <div className="card-container">
                {iconCard.map((item) => (
                  <Card
                    key={item.id}
                    icon={item.icon}
                    title={item.title}
                    onClick={() => changeInfo(item.id)}
                    disabled={item.id === "forget_password"
                      ? ["forget_password", "forget_password_withdraw"].every((type) => disabledUpdateTypes.includes(type))
                      : disabledUpdateTypes.includes(item.id)}
                  />
                ))}
              </div>
              {disabledUpdateTypes.includes("other_note") ? (
                <div className="profile-note card-disabled">CSKH xác minh</div>
              ) : (
                <div className="profile-note" onClick={() => changeInfo("other_note")}>CSKH xác minh</div>
              )}
            </div>
          </div>
          <Popup open={openRequestHistoryResult} onClose={() => setOpenRequestHistoryResult(false)} position="center" closeOnDocumentClick overlayStyle={{ display: "flex", alignItems: "center", justifyContent: "center", background: "rgba(0, 0, 0, 0.35)" }} contentStyle={{ position: "relative", inset: "auto", width: "auto", padding: 0, border: "none", background: "transparent" }}>
            <div className="request-history-modal">
            <button type="button" className="request-history-modal-close" onClick={() => setOpenRequestHistoryResult(false)}><img src={iconClose} alt="Đóng" /></button>
            {requestHistory && <div className={`request-history-result status-${requestHistory.status}`}>
              <h3>KẾT QUẢ YÊU CẦU</h3>
              <p><strong>Loại yêu cầu:</strong> {REQUEST_TYPES[requestHistory.update_type] || requestHistory.update_type}</p>
              {(requestHistory.data_update?.content || requestHistory.content) && <p><strong>Nội dung yêu cầu:</strong> {requestHistory.data_update?.content || requestHistory.content}</p>}
              <p><strong>Trạng thái:</strong> {REQUEST_STATUS[requestHistory.status] || requestHistory.status}</p>
              {requestHistory.status === "no_process" && ["email", "phone_number"].includes(requestHistory.send_type) && <p className={`verification-status verification-${requestHistory.verification_status || "not_received"}`}>{verificationText(requestHistory.verification_status || "not_received", requestHistory.send_type)}</p>}
              {(requestHistory.note || requestHistory.result) && <div><strong>Ghi chú/Kết quả:</strong><HtmlNote html={requestHistory.note || requestHistory.result} /></div>}
              {(requestHistory.createdAt || requestHistory.created_at) && <p><strong>Ngày gửi:</strong> {new Date(requestHistory.createdAt || requestHistory.created_at).toLocaleString("vi-VN")}</p>}
            </div>}
            </div>
          </Popup>
        </motion.div>
      </div>
    );
  }
}

export default Profile;
